import { useTexture } from "@react-three/drei";
import React, { useMemo, useState, useEffect } from "react";
import {
  EquirectangularReflectionMapping,
  sRGBEncoding,
  VideoTexture,
} from "three";

const TVScreen = ({ src, position, rotation, scale }) => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [videoProgress, setVideoProgress] = useState(0);
  const playButton = useTexture("/img/textures/playButton.png");
  const pauseButton = useTexture("/img/textures/pauseButton.png");

  const envMap = useTexture("/img/textures/envMap.png");
  envMap.mapping = EquirectangularReflectionMapping;

  const video = useMemo(() => {
    const vid = document.createElement("video");
    vid.src = src;
    vid.crossOrigin = "Anonymous";
    vid.setAttribute("playsinline", "playsinline");
    vid.loop = true;
    vid.muted = false;
    return vid;
  }, [src]);

  const videoTexture = useMemo(() => {
    const texture = new VideoTexture(video);
    texture.encoding = sRGBEncoding;
    return texture;
  }, [video]);

  function updateProgress() {
    const progress = video.currentTime / video.duration;
    setVideoProgress(progress);
  }

  useEffect(() => {
    if (video) {
      video.addEventListener("timeupdate", updateProgress);
    }
    if (isVideoPlaying) {
      video.play();
    } else {
      video.pause();
    }

    return () => {
      //get rid of the video
      if (video) {
        video.removeEventListener("timeupdate", updateProgress);
      }
    };
  }, [isVideoPlaying, video]);

  if (!video) {
    return null;
  }

  return (
    <group
      position={position}
      rotation={rotation}
      scale={scale}
      onClick={(e) => {
        e.stopPropagation();
        setIsVideoPlaying(!isVideoPlaying);
      }}
      onPointerEnter={(e) => {
        e.stopPropagation();
        document.body.style.cursor = "pointer";
      }}
      onPointerLeave={(e) => {
        e.stopPropagation();
        document.body.style.cursor = "default";
      }}
    >
      <sprite position={[0, 0.7, 0]} scale={[0.2, 0.2, 0.2]}>
        <spriteMaterial
          attach="material"
          map={isVideoPlaying ? pauseButton : playButton}
          transparent={true}
          opacity={0.9}
        />
      </sprite>
      <group position={[-0.8, 0, 0]} scale={[videoProgress, 1, 1]}>
        <mesh position={[0.8, 0.55, 0]}>
          <boxGeometry args={[1.6, 0.02, 0.02]} />
          <meshBasicMaterial color="green" />
        </mesh>
      </group>

      <mesh scale={[1.04, 1.04, 1.04]} position={[0, 0, -0.007]}>
        <planeGeometry args={[1.58, 0.9]} />
        <meshBasicMaterial color="black" />
      </mesh>
      <mesh position={[0, 0, 0]}>
        <planeGeometry args={[1.6, 0.9]} />
        <meshStandardMaterial
          map={videoTexture}
          envMap={envMap}
          roughness={0}
          metalness={0}
        />
      </mesh>
    </group>
  );
};

export default TVScreen;
